import { render, staticRenderFns } from "./PdpReport.vue?vue&type=template&id=2af5c27c"
import script from "./PdpReport.vue?vue&type=script&lang=js"
export * from "./PdpReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports